import React, { useState, useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { mantenimientoService } from "../services/mantenimiento";

const MESES = ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'];
function formatFecha(str) {
    if (!str) return '—';
    const [y, m, d] = str.split('-');
    return `${d} ${MESES[parseInt(m) - 1]} ${y}`;
}
function formatFechaTs(ts) {
    if (!ts) return '—';
    const d = new Date(ts);
    return `${d.getDate()} ${MESES[d.getMonth()]} ${d.getFullYear()}`;
}
function formatKm(km) {
    return km != null ? km.toLocaleString('es-PE') + ' km' : '—';
}
function calcDias(fechaStr) {
    if (!fechaStr) return null;
    const hoy = new Date(); hoy.setHours(0,0,0,0);
    const f   = new Date(fechaStr); f.setHours(0,0,0,0);
    return Math.round((f - hoy) / 86400000);
}
function formatDias(d) {
    if (d == null) return '—';
    if (d === 0) return 'Hoy';
    return d > 0 ? `${d} día${d !== 1 ? 's' : ''}` : `Vencido hace ${Math.abs(d)} día${Math.abs(d) !== 1 ? 's' : ''}`;
}
function statusFromKm(restantes, tolerancia) {
    if (restantes <= 0) return 'vencido';
    if (tolerancia != null && restantes <= tolerancia) return 'proximo';
    return 'aldia';
}
function statusFromDias(dias, tolerancia) {
    if (dias == null) return null;
    if (dias <= 0) return 'vencido';
    if (tolerancia != null && dias <= tolerancia) return 'proximo';
    return 'aldia';
}
const STATUS = {
    aldia:   { bg: '#dcfce7', color: '#15803d', label: 'Al día',           icon: 'bi-check-circle-fill' },
    proximo: { bg: '#fef9c3', color: '#b45309', label: 'Próximo a vencer', icon: 'bi-exclamation-circle-fill' },
    vencido: { bg: '#fee2e2', color: '#b91c1c', label: 'Vencido',          icon: 'bi-x-circle-fill' },
};

const StatusBadge = ({ status }) => {
    if (!status) return null;
    const s = STATUS[status];
    return (
        <span className="rsm-badge" style={{ background: s.bg, color: s.color, border:`1px solid ${s.color}33` }}>
            <i className={`bi ${s.icon}`} style={{ marginRight:'.3rem' }}></i>{s.label}
        </span>
    );
};

const MetricBlock = ({ value, label, color }) => (
    <div style={{ textAlign:'center', padding:'.65rem 0 1rem', borderBottom:'1px solid #f1f5f9', marginBottom:'.85rem' }}>
        <div style={{ fontSize:'1.5rem', fontWeight:800, letterSpacing:'-.03em', color, lineHeight:1 }}>{value}</div>
        <div style={{ fontSize:'.73rem', color:'#475569', marginTop:'.25rem' }}>{label}</div>
    </div>
);

const InfoRow = ({ lbl, val, valStyle }) => (
    <div className="rsm-irow">
        <span className="rsm-irow-lbl">{lbl}</span>
        <span className="rsm-irow-val" style={valStyle}>{val}</span>
    </div>
);

const CardSpin = () => (
    <div style={{ textAlign:'center', padding:'2rem 0' }}>
        <div className="rsm-spin"></div>
        <p style={{ fontSize:'.78rem', color:'#475569', margin:'.5rem 0 0' }}>Cargando...</p>
    </div>
);

export function Resumen() {
    const navigate = useNavigate();
    const [params] = useSearchParams();

    const idactivo    = params.get('idactivo')     ?? '';
    const tipo        = params.get('tipo')          ?? '';
    const codigo      = params.get('codigo')        ?? '';
    const idpersonal  = params.get('idpersonal')    ?? '';
    const tipovehiculo = params.get('tipovehiculo') ?? 0;
    const placa       = params.get('placa')         ?? '';

    const [inventario, setInventario] = useState(undefined);
    const [mant,       setMant]       = useState(undefined);
    const [periodo,    setPeriodo]    = useState('');

    useEffect(() => {
        fetch(process.env.REACT_APP_INVENTARIO_API_URL + "api/inventario/obtenerInventarioActualxidActivo/" + idactivo)
            .then(r => r.json())
            .then(res => {
                setInventario(res.rest == 1 ? res.inventario : null);
                if (res.rest == 1 && res.inventario?.periodo?.nombre) setPeriodo(res.inventario.periodo.nombre);
            })
            .catch(() => setInventario(null));

        fetch(process.env.REACT_APP_INVENTARIO_API_URL + "api/periodo/periodoActivo")
            .then(r => r.json())
            .then(res => { if (res.rest == 1) setPeriodo(p => p || res.periodo.nombre); })
            .catch(() => {});

        if (tipo === 'flota') {
            mantenimientoService.getResumenXPlaca(placa)
                .then(data => setMant(data))
                .catch(() => setMant(null));
        } else {
            setMant(null);
        }
    }, []);

    const irAInventario    = () => navigate(`/activo/inventario/?idactivo=${idactivo}&tipo=${tipo}&codigo=${codigo}&idpersonal=${idpersonal}&tipovehiculo=${tipovehiculo}`);
    const irAMantenimiento = () => navigate(`/activo/mantenimiento/?idactivo=${idactivo}&tipo=${tipo}&codigo=${codigo}&placa=${placa}`);
    const volverUrl = `/activo?idactivo=${idactivo}&tipo=${tipo}&codigo=${codigo}`;

    return (
        <div className="rsm-page">
            <style>{`
                .rsm-page {
                    max-width: 1200px; margin: 0 auto;
                    padding: 1.5rem 1rem 4rem;
                    background: #f8fafc; min-height: 100vh;
                }
                @media (min-width: 768px) { .rsm-page { padding: 2rem 2rem 4rem; } }

                /* Header */
                .rsm-header { display:flex; align-items:flex-start; gap:1rem; margin-bottom:2rem; flex-wrap:wrap; }
                .rsm-back {
                    display:inline-flex; align-items:center; gap:.35rem; flex-shrink:0;
                    color:#64748b; text-decoration:none; font-size:.82rem; font-weight:500;
                    background:#fff; border:1px solid #e2e8f0; border-radius:.5rem; padding:.45rem .9rem;
                    transition:color .15s, border-color .15s, box-shadow .15s;
                }
                .rsm-back:hover { color:#c81e22; border-color:#fecaca; box-shadow:0 1px 4px rgba(200,30,34,.1); }
                .rsm-title { margin:0; font-size:1.5rem; font-weight:800; color:#0f172a; letter-spacing:-.025em; line-height:1.2; }
                .rsm-subtitle { font-size:.82rem; color:#334155; margin:.2rem 0 0; }
                .rsm-tipo-badge {
                    display:inline-flex; align-items:center; gap:.3rem; margin-top:.45rem;
                    font-size:.68rem; font-weight:700; letter-spacing:.07em; text-transform:uppercase;
                    padding:.28rem .75rem; border-radius:.4rem;
                }
                .rsm-tipo-flota   { background:#fdf2f2; color:#c81e22; border:1px solid #fecaca; }
                .rsm-tipo-general { background:#f0fdf4; color:#15803d; border:1px solid #bbf7d0; }

                /* Grid */
                .rsm-grid { display:grid; grid-template-columns:1fr; gap:1.25rem; align-items:start; }
                @media (min-width: 768px) { .rsm-grid { grid-template-columns:1fr 1fr; gap:1.5rem; } }

                /* Cards */
                .rsm-card {
                    background:#fff; border-radius:1rem; overflow:hidden;
                    border:1px solid #e2e8f0;
                    box-shadow:0 1px 3px rgba(0,0,0,.05), 0 4px 16px rgba(0,0,0,.04);
                    display:flex; flex-direction:column;
                }
                .rsm-card-hdr {
                    display:flex; align-items:center; gap:.75rem; flex-wrap:wrap;
                    padding:1.1rem 1.5rem; background:#fafafa; border-bottom:1px solid #f1f5f9;
                }
                .rsm-card-icon {
                    width:34px; height:34px; border-radius:.5rem; flex-shrink:0;
                    display:flex; align-items:center; justify-content:center;
                }
                .rsm-card-title { font-weight:700; font-size:.92rem; color:#0f172a; }
                .rsm-card-body { padding:1.35rem 1.5rem; flex:1; display:flex; flex-direction:column; gap:.1rem; }
                .rsm-card-foot { padding:0 1.5rem 1.5rem; }

                /* Info rows */
                .rsm-irow {
                    display:flex; justify-content:space-between; align-items:baseline;
                    padding:.5rem 0; border-bottom:1px solid #f8fafc; gap:.5rem;
                }
                .rsm-irow:last-child { border-bottom:none; }
                .rsm-irow-lbl { font-size:.78rem; color:#334155; flex-shrink:0; }
                .rsm-irow-val { font-size:.85rem; font-weight:600; color:#0f172a; text-align:right; }

                /* Section label */
                .rsm-section-lbl {
                    font-size:.67rem; font-weight:700; letter-spacing:.09em;
                    text-transform:uppercase; color:#475569;
                }

                /* Inv status block */
                .rsm-inv-status {
                    display:flex; align-items:center; gap:.75rem; margin-bottom:1rem;
                    padding:.85rem 1rem; border-radius:.75rem;
                }
                .rsm-inv-dot {
                    width:32px; height:32px; border-radius:50%; flex-shrink:0;
                    display:flex; align-items:center; justify-content:center;
                }

                /* Badges */
                .rsm-badge {
                    display:inline-flex; align-items:center;
                    font-size:.65rem; font-weight:700; letter-spacing:.05em;
                    text-transform:uppercase; padding:.22rem .65rem; border-radius:100px;
                }

                /* Buttons */
                .rsm-btn {
                    display:flex; align-items:center; justify-content:center; gap:.5rem;
                    width:100%; padding:.9rem; border-radius:.875rem;
                    font-size:.9rem; font-weight:600; border:none; cursor:pointer;
                    transition:transform .15s, box-shadow .2s; text-decoration:none;
                }
                .rsm-btn:hover:not(:disabled) { transform:translateY(-1px); }
                .rsm-btn-red  { background:linear-gradient(135deg,#c81e22,#83090b); color:#fff; box-shadow:0 4px 14px rgba(200,30,34,.25); }
                .rsm-btn-dark { background:linear-gradient(135deg,#0f172a,#1e293b); color:#fff; box-shadow:0 4px 14px rgba(15,23,42,.2); }
                .rsm-btn-red:hover  { box-shadow:0 6px 20px rgba(200,30,34,.38) !important; color:#fff; }
                .rsm-btn-dark:hover { box-shadow:0 6px 20px rgba(15,23,42,.32) !important; color:#fff; }

                /* Spinner */
                .rsm-spin {
                    width:28px; height:28px; border-radius:50%;
                    border:3px solid #fde8e8; border-top-color:#c81e22;
                    animation:rspin .75s linear infinite; display:inline-block;
                }
                @keyframes rspin { to { transform:rotate(360deg); } }
            `}</style>

            {/* ── Header ── */}
            <div className="rsm-header">
                <Link to={volverUrl} className="rsm-back">
                    <i className="bi bi-arrow-left"></i> Volver
                </Link>
                <div>
                    <h1 className="rsm-title">{codigo || `Activo #${idactivo}`}</h1>
                    <p className="rsm-subtitle">
                        ID #{idactivo}
                        {periodo && <span style={{ marginLeft:'.5rem', color:'#475569' }}>· {periodo}</span>}
                    </p>
                    {tipo === 'flota'   && <span className="rsm-tipo-badge rsm-tipo-flota"><i className="bi bi-truck"></i>Flota</span>}
                    {tipo === 'general' && <span className="rsm-tipo-badge rsm-tipo-general"><i className="bi bi-archive"></i>General</span>}
                </div>
            </div>

            {/* ── Grid ── */}
            <div className="rsm-grid">

                {/* Inventario */}
                <div className="rsm-card">
                    <div className="rsm-card-hdr">
                        <div className="rsm-card-icon" style={{ background:'#fdf2f2' }}>
                            <i className="bi bi-clipboard2-check" style={{ color:'#c81e22', fontSize:'.95rem' }}></i>
                        </div>
                        <span className="rsm-card-title">Inventario</span>
                        {periodo && <span style={{ marginLeft:'auto', fontSize:'.75rem', color:'#94a3b8' }}>{periodo}</span>}
                    </div>

                    <div className="rsm-card-body">
                        {inventario === undefined ? (
                            <CardSpin />
                        ) : inventario ? (
                            <>
                                <div className="rsm-inv-status" style={{ background:'#f0fdf4' }}>
                                    <div className="rsm-inv-dot" style={{ background:'#dcfce7' }}>
                                        <i className="bi bi-check-lg" style={{ color:'#16a34a', fontSize:'.9rem' }}></i>
                                    </div>
                                    <span style={{ fontWeight:600, color:'#15803d', fontSize:'.88rem' }}>Inventariado en este periodo</span>
                                </div>
                                <InfoRow lbl="Responsable" val={inventario.personal?.nombre ?? '—'} />
                                {inventario.observacion && (
                                    <InfoRow lbl="Observación" val={inventario.observacion} valStyle={{ fontWeight:400, color:'#64748b' }} />
                                )}
                            </>
                        ) : (
                            <div className="rsm-inv-status" style={{ background:'#fffbeb' }}>
                                <div className="rsm-inv-dot" style={{ background:'#fef9c3' }}>
                                    <i className="bi bi-hourglass-split" style={{ color:'#d97706', fontSize:'.8rem' }}></i>
                                </div>
                                <span style={{ fontWeight:600, color:'#b45309', fontSize:'.88rem' }}>Pendiente de inventario</span>
                            </div>
                        )}
                    </div>

                    <div className="rsm-card-foot">
                        <button className="rsm-btn rsm-btn-red" onClick={irAInventario}>
                            <i className="bi bi-clipboard2-check"></i>
                            {inventario ? 'Actualizar inventario' : 'Iniciar inventario'}
                        </button>
                    </div>
                </div>

                {/* Mantenimiento */}
                {tipo === 'flota' && (
                    <div className="rsm-card">
                        <div className="rsm-card-hdr">
                            <div className="rsm-card-icon" style={{ background:'#eff6ff' }}>
                                <i className="bi bi-tools" style={{ color:'#1d4ed8', fontSize:'.95rem' }}></i>
                            </div>
                            <span className="rsm-card-title">Mantenimiento preventivo</span>
                        </div>

                        <div className="rsm-card-body">
                            {mant === undefined ? (
                                <CardSpin />
                            ) : !mant || mant.encontrado === false ? (
                                <div style={{ textAlign:'center', padding:'1.5rem 0', color:'#94a3b8' }}>
                                    <i className="bi bi-calendar-x" style={{ fontSize:'1.75rem', display:'block', marginBottom:'.5rem' }}></i>
                                    <p style={{ fontSize:'.83rem', margin:0 }}>Sin información disponible</p>
                                </div>
                            ) : mant.ntipounidad === 1 ? (() => {
                                const dias   = calcDias(mant.dfechaestimada);
                                const status = statusFromDias(dias, mant.ntolerancia);
                                const col    = status ? STATUS[status].color : '#64748b';
                                return (
                                    <>
                                        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'.75rem' }}>
                                            <span className="rsm-section-lbl">Semirremolque</span>
                                            <StatusBadge status={status} />
                                        </div>
                                        <MetricBlock value={formatDias(dias)} label="para el próximo servicio" color={col} />
                                        <InfoRow lbl="Último servicio"  val={formatFechaTs(mant.dotfecha)} />
                                        <InfoRow lbl="Fecha programada" val={formatFechaTs(mant.dfechaestimada)} />
                                        {/*mant.ntolerancia != null && <InfoRow lbl="Tolerancia" val={`${mant.ntolerancia} día${mant.ntolerancia !== 1 ? 's' : ''}`} valStyle={{ color:'#64748b', fontWeight:400 }} />*/}
                                        <InfoRow lbl="Estado" val={mant.bprogramado ? 'Programado' : 'No programado'} />
                                    </>
                                );
                            })() : mant.ntipounidad === 2 ? (() => {
                                const rest   = mant.nkmprogramado - mant.nkm;
                                const status = statusFromKm(rest, mant.ntolerancia);
                                const col    = STATUS[status].color;
                                return (
                                    <>
                                        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'.75rem' }}>
                                            <span className="rsm-section-lbl">Remolcador</span>
                                            <StatusBadge status={status} />
                                        </div>
                                        <MetricBlock value={formatKm(rest)} label="km restantes" color={col} />
                                        <InfoRow lbl="Km actual"      val={formatKm(mant.nkm)} />
                                        <InfoRow lbl="Fecha Km"   val={formatFechaTs(mant.dfechakm)} />
                                        <InfoRow lbl="Km programado"  val={formatKm(mant.nkmprogramado)} />
                                        {/*mant.ntolerancia != null && <InfoRow lbl="Tolerancia" val={formatKm(mant.ntolerancia)} valStyle={{ color:'#64748b', fontWeight:400 }} />*/}
                                        <InfoRow lbl="Fecha estimada" val={formatFechaTs(mant.dfechaestimadapromedio)} />
                                        <InfoRow lbl="Estado"         val={mant.bprogramado ? 'Programado' : 'No programado'} />
                                    </>
                                );
                            })() : mant.ntipounidad === 3 ? (() => {
                                const dias   = calcDias(mant.dfechaprogramada);
                                const status = statusFromDias(dias, mant.ntolerancia);
                                const col    = status ? STATUS[status].color : '#64748b';
                                return (
                                    <>
                                        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'.75rem' }}>
                                            <span className="rsm-section-lbl">Modular</span>
                                            <StatusBadge status={status} />
                                        </div>
                                        <MetricBlock value={formatDias(dias)} label="para el próximo servicio" color={col} />
                                        <InfoRow lbl="Último servicio"  val={formatFecha(mant.dfechaejecutada)} />
                                        <InfoRow lbl="Fecha programada" val={formatFecha(mant.dfechaprogramada)} />
                                        {mant.ntolerancia != null && <InfoRow lbl="Tolerancia" val={`${mant.ntolerancia} día${mant.ntolerancia !== 1 ? 's' : ''}`} valStyle={{ color:'#64748b', fontWeight:400 }} />}
                                        <InfoRow lbl="Estado" val={mant.bprogramado ? 'Programado' : 'No programado'} />
                                    </>
                                );
                            })() : (
                                <p style={{ color:'#94a3b8', textAlign:'center', fontSize:'.88rem', margin:0 }}>Tipo de unidad no reconocido</p>
                            )}
                        </div>

                        <div className="rsm-card-foot">
                            <button className="rsm-btn rsm-btn-dark" onClick={irAMantenimiento}>
                                <i className="bi bi-clock-history"></i>
                                Ver historial completo
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
